import {Observable} from 'rxjs';
import {TranslateLoader} from '@ngx-translate/core';

export abstract class CommonTranslateLoader extends TranslateLoader {

    getTranslation(lang: string): Observable<any> {
        let commonPack = require('./translations/' + lang + '/index.ts').LOCALE,
            modulePack = this.getModuleTranslation(lang);

        return Observable.of(Object.assign({}, commonPack, modulePack));
    }

    abstract getModuleTranslation(lang: string): any;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/common.translate.loader.ts